export const ALK_ADMIN = 'ALK Administrator';
export const ALK_SUPPORT = 'ALK Support';

export const ALK_ROLES = new Set([ALK_ADMIN, ALK_SUPPORT]);
